import Adjustment from '@/components/Adjustment.vue'
import CalculationPreview from '@/components/CalculationPreview.vue'
import InputCheckboxes from '@/components/InputCheckboxes.vue'
import InputDate from '@/components/InputDate.vue'
import InputDateTime from '@/components/InputDateTime.vue'
import InputEmail from '@/components/InputEmail.vue'
import InputGhgEmission from '@/components/InputGhgEmission.vue'
import InputImageUpload from '@/components/InputImageUpload.vue'
import InputListString from '@/components/InputListString.vue'
import InputLocation from '@/components/InputLocation.vue'
import InputNumber from '@/components/InputNumber.vue'
import InputPhoneNumber from '@/components/InputPhoneNumber.vue'
import InputReference from '@/components/InputReference.vue'
import InputSingleSelect from '@/components/InputSingleSelect.vue'
import InputWeightMeasurement from '@/components/InputWeightMeasurement.vue'
import SignaturePad from '@/components/SignaturePad.vue'
import IconAirplane from '@/components/svg/IconAirplane.vue'
import IconContainer from '@/components/svg/IconContainer.vue'
import IconForkLift from '@/components/svg/IconForkLift.vue'
import IconGroupOfCode from '@/components/svg/IconGroupOfCode.vue'
import IconInventory from '@/components/svg/IconInventory.vue'
import IconMiniCode from '@/components/svg/IconMiniCode.vue'
import IconPackage from '@/components/svg/IconPackage.vue'
import IconPackages from '@/components/svg/IconPackages.vue'
import IconPaper from '@/components/svg/IconPaper.vue'
import IconPerson from '@/components/svg/IconPerson.vue'
import IconQRcode from '@/components/svg/IconQRcode.vue'
import IconRack from '@/components/svg/IconRack.vue'
import IconShip from '@/components/svg/IconShip.vue'
import IconTimeTable from '@/components/svg/IconTimeTable.vue'
import IconTrain from '@/components/svg/IconTrain.vue'
import IconTruck from '@/components/svg/IconTruck.vue'
import IconVaccine from '@/components/svg/IconVaccine.vue'
import IconWarehouse from '@/components/svg/IconWarehouse.vue'
import { EBCTypeIconKey, ECustomFieldType } from './enums'
import { ICountryPhoneInfo } from './types/commonTypes'
import { IAddress } from './types/fieldDefinition'

/**
 * FIXME: DELETE THIS
 */
export const BARCODE_READER_CATEGORY: Record<string, string> = Object.freeze({
  QR: 'QR',
  ONE_DIMENSION: '1D',
  DEFAULT: 'Default',
})

export const FIXED_PACKAGE_INFO_KEYS = Object.freeze([
  'trackingNumber',
  'externalId',
  'dimension',
  'width',
  'height',
  'weight',
  'depth',
])

export const MAX_IMAGE_SIZE = 1024

export const BACK_CAMERA_LABEL = Object.freeze(['back', '背面カメラ'])

export const IMAGE_EXTENSION = Object.freeze(['png', 'gif', 'tiff', 'bmp', 'jpeg', 'jpg', 'webp'])

export const getDefaultDialogConfig = () => {
  return {
    title: '',
    message: '',
    confirmation: true,
    needtranslation: false,
  }
}

export const FORCE_EXIT_ROUTE = Object.freeze(['home'])

export const ENTRY_VIEW: Record<string, string> = Object.freeze({
  ORIGIN: 'origin',
  DESTINATION: 'destination',
  PACKAGE_INFO: 'packageInfo',
})

export const SMARTBARCODE_TYPE: Record<string, string> = Object.freeze({
  MOBILE: 'mobile',
  PORTAL: 'portal',
})

export const LOCAL_STORAGE_ITEM: Record<string, string> = Object.freeze({
  VISITOR_ID: `${process.env.NODE_ENV}-Lozi-mobile-visitorId`,
  LAST_AUTHORIZED_SYSTEM: `${process.env.NODE_ENV}-last_authorized_system`,
  LAST_SELECTED_SYMBOLOGY: `${process.env.NODE_ENV}-last_selected_symbology`,
  KEYENCE_SCANNER_CONFIG_ISEXPANDING: `${process.env.NODE_ENV}-keyence-handy-terminal-expanding-scanner-config`,
  KEYENCE_SCANNER_CONFIG_AIMER_TARGET: `${process.env.NODE_ENV}-keyence-handy-terminal-scanner-config-aimer-target`,
  WORK_CENTER_CODE: `${process.env.NODE_ENV}-scanned-work-center-code`,
  CLIENT_LOG_QUEUE: `${process.env.NODE_ENV}-client-log-queue`,
})

export const getLocalStorageKey = {
  trackingDataDraft: (projectCode: string, barcodeId: string, selectedTarget: string) =>
    `${process.env.NODE_ENV}-${projectCode}.${barcodeId}.trackingData.${selectedTarget}`,
}

export const getSerialErrorMessage = (errorCode: string, errorKey: string): string => {
  const errorMessageMap: Record<string, string> = {
    3123: `${errorKey} は期限切れです。`,
    3110: `シリアル ${errorKey.toUpperCase()} は存在しません。`,
    3143: `シリアル ${errorKey.toUpperCase()} はこの製造オーダーで未使用のため登録できません。`,
  }
  return errorMessageMap[errorCode] || ''
}

export const trollyNumberLimitTP = 30
export const trollyNumberLimitBT = 48

export const BARCODE_TYPE_ICONS: Record<string, unknown> = Object.freeze({
  [EBCTypeIconKey.NODE]: IconGroupOfCode,
  [EBCTypeIconKey.LEAF]: IconMiniCode,
  [EBCTypeIconKey.ORPHAN]: IconQRcode,
  [EBCTypeIconKey.VACCINE]: IconVaccine,
  [EBCTypeIconKey.TRUCK]: IconTruck,
  [EBCTypeIconKey.CONTAINER]: IconContainer,
  [EBCTypeIconKey.TIMETABLE]: IconTimeTable,
  [EBCTypeIconKey.INVENTORY]: IconInventory,
  [EBCTypeIconKey.WAREHOUSE]: IconWarehouse,
  [EBCTypeIconKey.RACK]: IconRack,
  [EBCTypeIconKey.FORKLIFT]: IconForkLift,
  [EBCTypeIconKey.PACKAGES]: IconPackages,
  [EBCTypeIconKey.PACKAGE]: IconPackage,
  [EBCTypeIconKey.PAPER]: IconPaper,
  [EBCTypeIconKey.PERSON]: IconPerson,
  [EBCTypeIconKey.TRAIN]: IconTrain,
  [EBCTypeIconKey.SHIP]: IconShip,
  [EBCTypeIconKey.AIRPLANE]: IconAirplane,
})

export const INPUT_COMPONENTS: Record<string, unknown> = Object.freeze({
  [ECustomFieldType.MULTI_SELECT]: InputCheckboxes,
  [ECustomFieldType.SINGLE_SELECT]: InputSingleSelect,
  [ECustomFieldType.DATE]: InputDate,
  [ECustomFieldType.DATE_TIME_DATA]: InputDateTime,
  [ECustomFieldType.ESIGN]: SignaturePad,
  [ECustomFieldType.NUMBER]: InputNumber,
  [ECustomFieldType.FILES]: InputImageUpload,
  [ECustomFieldType.PHONE_NUMBER]: InputPhoneNumber,
  [ECustomFieldType.EMAIL]: InputEmail,
  [ECustomFieldType.LOCATION]: InputLocation,
  [ECustomFieldType.REFERENCE]: InputReference,
  [ECustomFieldType.GHG_EMISSION]: InputGhgEmission,
  [ECustomFieldType.CALCULATION]: CalculationPreview,
  [ECustomFieldType.ADJUSTMENT]: Adjustment,
  [ECustomFieldType.LIST_STRING]: InputListString,
  [ECustomFieldType.WEIGHT_MEASUREMENT]: InputWeightMeasurement,
})

export const BARCODE_SCAN: Record<string, number> = Object.freeze({
  // Time delay for next scan between 2 scans on multi-scan barcode
  timeBetweenScansMillis: 500,
})

export const DEFAULT_ADDRESS: IAddress = Object.freeze({
  companyName: '',
  country: '',
  postalCode: '',
  prefecture: '',
  address1: '',
  address2: '',
  phoneNumber: '',
})

export const DEFAULT_ACTIVATION_DATA = Object.freeze({
  origin: {},
  destination: {},
})

export const countryList = Object.freeze([
  'JPN',
  'USA',
  'CHN',
  'ABW',
  'AFG',
  'AGO',
  'AIA',
  'ALA',
  'ALB',
  'AND',
  'ARE',
  'ARG',
  'ARM',
  'ASM',
  'ATA',
  'ATF',
  'ATG',
  'AUS',
  'AUT',
  'AZE',
  'BDI',
  'BEL',
  'BEN',
  'BES',
  'BFA',
  'BGD',
  'BGR',
  'BHR',
  'BHS',
  'BIH',
  'BLM',
  'BLR',
  'BLZ',
  'BMU',
  'BOL',
  'BRA',
  'BRB',
  'BRN',
  'BTN',
  'BVT',
  'BWA',
  'CAF',
  'CAN',
  'CCK',
  'CHE',
  'CHL',
  'CIV',
  'CMR',
  'COD',
  'COG',
  'COK',
  'COL',
  'COM',
  'CPV',
  'CRI',
  'CUB',
  'CUW',
  'CXR',
  'CYM',
  'CYP',
  'CZE',
  'DEU',
  'DJI',
  'DMA',
  'DNK',
  'DOM',
  'DZA',
  'ECU',
  'EGY',
  'ERI',
  'ESH',
  'ESP',
  'EST',
  'ETH',
  'FIN',
  'FJI',
  'FLK',
  'FRA',
  'FRO',
  'FSM',
  'GAB',
  'GBR',
  'GEO',
  'GGY',
  'GHA',
  'GIB',
  'GIN',
  'GLP',
  'GMB',
  'GNB',
  'GNQ',
  'GRC',
  'GRD',
  'GRL',
  'GTM',
  'GUF',
  'GUM',
  'GUY',
  'HKG',
  'HMD',
  'HND',
  'HRV',
  'HTI',
  'HUN',
  'IDN',
  'IMN',
  'IND',
  'IOT',
  'IRL',
  'IRN',
  'IRQ',
  'ISL',
  'ISR',
  'ITA',
  'JAM',
  'JEY',
  'JOR',
  'KAZ',
  'KEN',
  'KGZ',
  'KHM',
  'KIR',
  'KNA',
  'KOR',
  'KWT',
  'LAO',
  'LBN',
  'LBR',
  'LBY',
  'LCA',
  'LIE',
  'LKA',
  'LSO',
  'LTU',
  'LUX',
  'LVA',
  'MAC',
  'MAF',
  'MAR',
  'MCO',
  'MDA',
  'MDG',
  'MDV',
  'MEX',
  'MHL',
  'MKD',
  'MLI',
  'MLT',
  'MMR',
  'MNE',
  'MNG',
  'MNP',
  'MOZ',
  'MRT',
  'MSR',
  'MTQ',
  'MUS',
  'MWI',
  'MYS',
  'MYT',
  'NAM',
  'NCL',
  'NER',
  'NFK',
  'NGA',
  'NIC',
  'NIU',
  'NLD',
  'NOR',
  'NPL',
  'NRU',
  'NZL',
  'OMN',
  'PAK',
  'PAN',
  'PCN',
  'PER',
  'PHL',
  'PLW',
  'PNG',
  'POL',
  'PRI',
  'PRK',
  'PRT',
  'PRY',
  'PSE',
  'PYF',
  'QAT',
  'REU',
  'ROU',
  'RUS',
  'RWA',
  'SAU',
  'SDN',
  'SEN',
  'SGP',
  'SGS',
  'SHN',
  'SJM',
  'SLB',
  'SLE',
  'SLV',
  'SMR',
  'SOM',
  'SPM',
  'SRB',
  'SSD',
  'STP',
  'SUR',
  'SVK',
  'SVN',
  'SWE',
  'SWZ',
  'SXM',
  'SYC',
  'SYR',
  'TCA',
  'TCD',
  'TGO',
  'THA',
  'TJK',
  'TKL',
  'TKM',
  'TLS',
  'TON',
  'TTO',
  'TUN',
  'TUR',
  'TUV',
  'TWN',
  'TZA',
  'UGA',
  'UKR',
  'UMI',
  'URY',
  'UZB',
  'VAT',
  'VCT',
  'VEN',
  'VGB',
  'VIR',
  'VNM',
  'VUT',
  'WLF',
  'WSM',
  'YEM',
  'ZAF',
  'ZMB',
  'ZWE',
])

export const SUCCESS_SOUND = Object.freeze(
  'data:audio/mp3;base64,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'
)
export const FAIL_SOUND = Object.freeze(
  'data:audio/mp3;base64,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'
)

// eslint-disable-next-line no-useless-escape
export const QRCODE_BARCODE_TYPE_REGEX = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/\n]+)(\:)?(\d*)?(\/){1}([^:\/\n]+)(\/){1}([^:\/\n]+)(\/){1}([^:\/\n]+)$/i
// eslint-disable-next-line no-useless-escape
export const QRCODE_BARCODE_TYPE_REGEX_NEW = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/\n]+)(\:)?(\d*)?(\/){1}([^:\/\n]+)(\/){1}([^:\/\n]+)$/i

export const CURRENT_CAMERA_KEY = 'currentScanCameraId'

export const MASKED_ANNOTATION = '***'
export const MASKED_PACKAGE_DIMENSION = Object.freeze({
  width: MASKED_ANNOTATION,
  height: MASKED_ANNOTATION,
  depth: MASKED_ANNOTATION,
  weight: MASKED_ANNOTATION,
})

export const MASKED_ADDRESS: IAddress = Object.freeze({
  companyName: MASKED_ANNOTATION,
  country: MASKED_ANNOTATION,
  postalCode: MASKED_ANNOTATION,
  prefecture: MASKED_ANNOTATION,
  address1: MASKED_ANNOTATION,
  address2: MASKED_ANNOTATION,
  phoneNumber: MASKED_ANNOTATION,
})

export const SB_FORCE_UPGRADE_VERSION_KEY = 'x-smartbarcode-is-forced-version'
export const SB_MOBILE_VERSION_KEY = 'x-smartbarcode-mobile-version'
export const SB_PORTAL_VERSION_KEY = 'x-smartbarcode-portal-version'

export const IMAGES_EXTENSIONS = Object.freeze(['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.tiff', '.webp', '.svg'])

export const OTHER_COUNTRY_LIST = Object.freeze(({
  JP: {
    code: 'JPN',
    mask: ['###-####-####', '##-####-####'],
    dialCode: '+81',
  },
  US: {
    code: 'USA',
    mask: ['###-####-####', '##-####-####'],
    dialCode: '+1',
  },
  CN: {
    code: 'CHN',
    mask: ['###-####-####', '##-####-####'],
    dialCode: '+86',
  },
  AD: {
    code: 'AND',
    mask: ['###-###'],
    dialCode: '+376',
  },
  AE: {
    code: 'ARE',
    mask: ['0##-###-####', '0#-###-####'],
    dialCode: '+971',
  },
  AF: {
    code: 'AFG',
    mask: ['0##-###-####'],
    dialCode: '+93',
  },
  AG: {
    code: 'ATG',
    mask: ['1###-####'],
    dialCode: '+1268',
  },
  AI: {
    code: 'AIA',
    mask: ['1###-####'],
    dialCode: '+1264',
  },
  AL: {
    code: 'ALB',
    mask: ['0###-###-###'],
    dialCode: '+355',
  },
  AM: {
    code: 'ARM',
    mask: ['0##-###-###'],
    dialCode: '+374',
  },
  AO: {
    code: 'AGO',
    mask: ['###-###-###'],
    dialCode: '+244',
  },
  AQ: {
    code: 'ATA',
    mask: ['###-###'],
    dialCode: '+672',
  },
  AR: {
    code: 'ARG',
    mask: ['0###-###-####'],
    dialCode: '+54',
  },
  AS: {
    code: 'ASM',
    mask: ['1###-####'],
    dialCode: '+1684',
  },
  AT: {
    code: 'AUT',
    mask: ['0###-###-####'],
    dialCode: '+43',
  },
  AU: {
    code: 'AUS',
    mask: ['0#-####-####'],
    dialCode: '+61',
  },
  AX: {
    code: 'ALA',
    mask: ['0 457 ###-####'],
    dialCode: '+358',
  },
  AW: {
    code: 'ABW',
    mask: ['###-####'],
    dialCode: '+297',
  },
  AZ: {
    code: 'AZE',
    mask: ['0##-###-##-##'],
    dialCode: '+994',
  },
  BA: {
    code: 'BIH',
    mask: ['0##-#####', '0##-####'],
    dialCode: '+387',
  },
  BB: {
    code: 'BRB',
    mask: ['1###-####'],
    dialCode: '+1246',
  },
  BD: {
    code: 'BGD',
    mask: ['0##-###-###'],
    dialCode: '+880',
  },
  BE: {
    code: 'BEL',
    mask: ['0###-###-###'],
    dialCode: '+32',
  },
  BF: {
    code: 'BFA',
    mask: ['##-##-####'],
    dialCode: '+226',
  },
  BG: {
    code: 'BGR',
    mask: ['0###-###-###'],
    dialCode: '+359',
  },
  BH: {
    code: 'BHR',
    mask: ['####-####'],
    dialCode: '+973',
  },
  BI: {
    code: 'BDI',
    mask: ['##-##-####'],
    dialCode: '+257',
  },
  BJ: {
    code: 'BEN',
    mask: ['##-##-####'],
    dialCode: '+229',
  },
  BQ: {
    code: 'BES',
    mask: null,
    dialCode: '',
  },
  BL: {
    code: 'BLM',
    mask: null,
    dialCode: '+590',
  },
  BM: {
    code: 'BMU',
    mask: ['1###-####'],
    dialCode: '+1441',
  },
  BN: {
    code: 'BRN',
    mask: ['###-####'],
    dialCode: '+673',
  },
  BO: {
    code: 'BOL',
    mask: ['0#-###-####'],
    dialCode: '+591',
  },
  BR: {
    code: 'BRA',
    mask: ['0##-####-####'],
    dialCode: '+55',
  },
  BS: {
    code: 'BHS',
    mask: ['###-####'],
    dialCode: '+1242',
  },
  BT: {
    code: 'BTN',
    mask: ['##-######', '#-######'],
    dialCode: '+975',
  },
  BV: {
    code: 'BVT',
    mask: null,
    dialCode: '',
  },
  BW: {
    code: 'BWA',
    mask: ['###-#####', '##-#####'],
    dialCode: '+267',
  },
  BY: {
    code: 'BLR',
    mask: ['80#-###-####.'],
    dialCode: '+375',
  },
  BZ: {
    code: 'BLZ',
    mask: ['###-####'],
    dialCode: '+501',
  },
  CA: {
    code: 'CAN',
    mask: ['1(###)###-####'],
    dialCode: '+1',
  },
  CC: {
    code: 'CCK',
    mask: null,
    dialCode: '+61',
  },
  CD: {
    code: 'COD',
    mask: ['0(###)###-###'],
    dialCode: '+243',
  },
  CF: {
    code: 'CAF',
    mask: ['##-##-####'],
    dialCode: '+236',
  },
  CG: {
    code: 'COG',
    mask: ['##-###-####'],
    dialCode: '+242',
  },
  CH: {
    code: 'CHE',
    mask: ['0##-###-####'],
    dialCode: '+41',
  },
  CI: {
    code: 'CIV',
    mask: ['##-####-####'],
    dialCode: '+225',
  },
  CK: {
    code: 'COK',
    mask: ['##-###'],
    dialCode: '+682',
  },
  CL: {
    code: 'CHL',
    mask: ['#-####-####'],
    dialCode: '+56',
  },
  CM: {
    code: 'CMR',
    mask: ['####-####'],
    dialCode: '+237',
  },
  CO: {
    code: 'COL',
    mask: ['0(###)###-####'],
    dialCode: '+57',
  },
  CR: {
    code: 'CRI',
    mask: ['####-####'],
    dialCode: '+506',
  },
  CU: {
    code: 'CUB',
    mask: ['0#-###-####'],
    dialCode: '+53',
  },
  CV: {
    code: 'CPV',
    mask: ['(###)##-##'],
    dialCode: '+238',
  },
  CW: {
    code: 'CUW',
    mask: ['0###-####'],
    dialCode: '+599',
  },
  CY: {
    code: 'CYP',
    mask: ['##-###-###'],
    dialCode: '+357',
  },
  CX: {
    code: 'CXR',
    mask: null,
    dialCode: '+61',
  },
  CZ: {
    code: 'CZE',
    mask: ['(###)###-###'],
    dialCode: '+420',
  },
  DE: {
    code: 'DEU',
    mask: ['0(####)###-####', '0(###)###-####', '0(###)##-####', '0(###)##-###', '0(###)##-##', '0###-###'],
    dialCode: '+49',
  },
  DJ: {
    code: 'DJI',
    mask: ['##-##-##-##'],
    dialCode: '+253',
  },
  DK: {
    code: 'DNK',
    mask: ['##-##-##-##'],
    dialCode: '+45',
  },
  DM: {
    code: 'DMA',
    mask: ['1###-####'],
    dialCode: '+1767',
  },
  DO: {
    code: 'DOM',
    mask: ['1###-####'],
    dialCode: '+1849',
  },
  DZ: {
    code: 'DZA',
    mask: ['0##-###-####'],
    dialCode: '+213',
  },
  EC: {
    code: 'ECU',
    mask: ['0##-###-####', '0#-###-####'],
    dialCode: '+593',
  },
  EE: {
    code: 'EST',
    mask: ['####-####', '###-####'],
    dialCode: '+372',
  },
  EG: {
    code: 'EGY',
    mask: ['0(###)###-####'],
    dialCode: '+20',
  },
  EH: {
    code: 'ESH',
    mask: null,
    dialCode: '+212',
  },
  ER: {
    code: 'ERI',
    mask: ['0#-###-###'],
    dialCode: '+291',
  },
  ES: {
    code: 'ESP',
    mask: ['(###)###-###'],
    dialCode: '+34',
  },
  ET: {
    code: 'ETH',
    mask: ['0##-###-####'],
    dialCode: '+251',
  },
  FI: {
    code: 'FIN',
    mask: ['0(###)###-##-##'],
    dialCode: '+358',
  },
  FJ: {
    code: 'FJI',
    mask: ['##-#####'],
    dialCode: '+679',
  },
  FK: {
    code: 'FLK',
    mask: ['#####'],
    dialCode: '+500',
  },
  FM: {
    code: 'FSM',
    mask: ['1###-####'],
    dialCode: '+691',
  },
  FO: {
    code: 'FRO',
    mask: ['###-###'],
    dialCode: '+298',
  },
  FR: {
    code: 'FRA',
    mask: ['0(###)###-###'],
    dialCode: '+33',
  },
  GA: {
    code: 'GAB',
    mask: ['0#-##-##-##'],
    dialCode: '+241',
  },
  GD: {
    code: 'GRD',
    mask: ['1###-####'],
    dialCode: '+1473',
  },
  GE: {
    code: 'GEO',
    mask: ['0(###)###-###'],
    dialCode: '+995',
  },
  GF: {
    code: 'GUF',
    mask: ['0#####-####'],
    dialCode: '+594',
  },
  GG: {
    code: 'GGY',
    mask: null,
    dialCode: '+44',
  },
  GH: {
    code: 'GHA',
    mask: ['0(###)###-###'],
    dialCode: '+233',
  },
  GI: {
    code: 'GIB',
    mask: ['###-#####'],
    dialCode: '+350',
  },
  GL: {
    code: 'GRL',
    mask: ['##-##-##'],
    dialCode: '+299',
  },
  GM: {
    code: 'GMB',
    mask: ['(###)##-##'],
    dialCode: '+220',
  },
  GN: {
    code: 'GIN',
    mask: ['###-###-###'],
    dialCode: '+224',
  },
  GP: {
    code: 'GLP',
    mask: null,
    dialCode: '+590',
  },
  GQ: {
    code: 'GNQ',
    mask: ['##-###-####'],
    dialCode: '+240',
  },
  GR: {
    code: 'GRC',
    mask: ['(###)###-####'],
    dialCode: '+30',
  },
  GS: {
    code: 'SGS',
    mask: null,
    dialCode: '+500',
  },
  GT: {
    code: 'GTM',
    mask: ['#-###-####'],
    dialCode: '+502',
  },
  GU: {
    code: 'GUM',
    mask: ['1###-####'],
    dialCode: '+1671',
  },
  GW: {
    code: 'GNB',
    mask: ['#-######'],
    dialCode: '+245',
  },
  GY: {
    code: 'GUY',
    mask: ['###-####'],
    dialCode: '+592',
  },
  HK: {
    code: 'HKG',
    mask: ['####-####'],
    dialCode: '+852',
  },
  HM: {
    code: 'HMD',
    mask: null,
    dialCode: '',
  },
  HN: {
    code: 'HND',
    mask: ['####-####'],
    dialCode: '+504',
  },
  HR: {
    code: 'HRV',
    mask: ['0##-###-###'],
    dialCode: '+385',
  },
  HT: {
    code: 'HTI',
    mask: ['##-##-####'],
    dialCode: '+509',
  },
  HU: {
    code: 'HUN',
    mask: ['06(###)###-###'],
    dialCode: '+36',
  },
  ID: {
    code: 'IDN',
    mask: ['0(8##)###-####', '0##-###-##', '0##-###-###', '0##-###-####', '8##-####-####'],
    dialCode: '+62',
  },
  IE: {
    code: 'IRL',
    mask: ['0(###)###-###'],
    dialCode: '+353',
  },
  IL: {
    code: 'ISR',
    mask: ['05#-###-####', '0#-###-####'],
    dialCode: '+972',
  },
  IM: {
    code: 'IMN',
    mask: null,
    dialCode: '+44',
  },
  IN: {
    code: 'IND',
    mask: ['0(####)###-###'],
    dialCode: '+91',
  },
  IO: {
    code: 'IOT',
    mask: ['###-####'],
    dialCode: '+246',
  },
  IQ: {
    code: 'IRQ',
    mask: ['(###)###-####', '(##)###-###', '(##)###-####'],
    dialCode: '+964',
  },
  IR: {
    code: 'IRN',
    mask: ['0(###)###-####'],
    dialCode: '+98',
  },
  IS: {
    code: 'ISL',
    mask: ['###-####'],
    dialCode: '+354',
  },
  IT: {
    code: 'ITA',
    mask: ['(###)####-###'],
    dialCode: '+39',
  },
  JE: {
    code: 'JEY',
    mask: null,
    dialCode: '+44',
  },
  JM: {
    code: 'JAM',
    mask: ['1###-####'],
    dialCode: '+1876',
  },
  JO: {
    code: 'JOR',
    mask: ['0#-####-####'],
    dialCode: '+962',
  },
  KE: {
    code: 'KEN',
    mask: ['0###-######'],
    dialCode: '+254',
  },
  KG: {
    code: 'KGZ',
    mask: ['0(###)###-###'],
    dialCode: '+996',
  },
  KH: {
    code: 'KHM',
    mask: ['0##-###-###'],
    dialCode: '+855',
  },
  KI: {
    code: 'KIR',
    mask: ['###-####'],
    dialCode: '+686',
  },
  KM: {
    code: 'COM',
    mask: ['##-#####'],
    dialCode: '+269',
  },
  KN: {
    code: 'KNA',
    mask: ['1###-####'],
    dialCode: '+1869',
  },
  KP: {
    code: 'PRK',
    mask: ['###-####-###', '####-####'],
    dialCode: '+850',
  },
  KR: {
    code: 'KOR',
    mask: ['0##-###-####', '0##-####-####'],
    dialCode: '+82',
  },
  KW: {
    code: 'KWT',
    mask: ['####-####'],
    dialCode: '+965',
  },
  KY: {
    code: 'CYM',
    mask: ['1###-####'],
    dialCode: '+345',
  },
  KZ: {
    code: 'KAZ',
    mask: ['8(6##)###-##-##', '0(7##)###-##-##'],
    dialCode: '+77',
  },
  LA: {
    code: 'LAO',
    mask: ['0(20##)###-###', '0##-###-###'],
    dialCode: '+856',
  },
  LB: {
    code: 'LBN',
    mask: ['0##-###-###', '0#-###-###'],
    dialCode: '+961',
  },
  LC: {
    code: 'LCA',
    mask: ['1###-####'],
    dialCode: '+1758',
  },
  LI: {
    code: 'LIE',
    mask: ['###-####'],
    dialCode: '+423',
  },
  LK: {
    code: 'LKA',
    mask: ['0##-###-####'],
    dialCode: '+94',
  },
  LR: {
    code: 'LBR',
    mask: ['##-###-####'],
    dialCode: '+231',
  },
  LS: {
    code: 'LSO',
    mask: ['#-###-####'],
    dialCode: '+266',
  },
  LT: {
    code: 'LTU',
    mask: ['8(###)##-###'],
    dialCode: '+370',
  },
  LU: {
    code: 'LUX',
    mask: ['(###)###-###', '(###)##-###', '(###)####', '(###)###', '(###)##'],
    dialCode: '+352',
  },
  LV: {
    code: 'LVA',
    mask: ['##-###-###'],
    dialCode: '+371',
  },
  LY: {
    code: 'LBY',
    mask: ['0##-###-###'],
    dialCode: '+218',
  },
  MA: {
    code: 'MAR',
    mask: ['0##-####-###'],
    dialCode: '+212',
  },
  MC: {
    code: 'MCO',
    mask: ['(###)###-###', '##-###-###'],
    dialCode: '+377',
  },
  MD: {
    code: 'MDA',
    mask: ['0####-####'],
    dialCode: '+373',
  },
  ME: {
    code: 'MNE',
    mask: ['0##-###-###'],
    dialCode: '+382',
  },
  MG: {
    code: 'MDG',
    mask: ['0##-##-#####'],
    dialCode: '+261',
  },
  MH: {
    code: 'MHL',
    mask: ['1###-####'],
    dialCode: '+692',
  },
  MK: {
    code: 'MKD',
    mask: ['0##-###-###'],
    dialCode: '+389',
  },
  ML: {
    code: 'MLI',
    mask: ['##-##-####'],
    dialCode: '+223',
  },
  MM: {
    code: 'MMR',
    mask: ['0##-###-###', '0#-###-###', '0-###-###'],
    dialCode: '+95',
  },
  MN: {
    code: 'MNG',
    mask: ['0##-##-####'],
    dialCode: '+976',
  },
  MO: {
    code: 'MAC',
    mask: ['####-####'],
    dialCode: '+853',
  },
  MP: {
    code: 'MNP',
    mask: ['1###-####'],
    dialCode: '+1670',
  },
  MQ: {
    code: 'MTQ',
    mask: ['0(###)##-##-##'],
    dialCode: '+596',
  },
  MR: {
    code: 'MRT',
    mask: ['##-##-####'],
    dialCode: '+222',
  },
  MS: {
    code: 'MSR',
    mask: ['1###-####'],
    dialCode: '+1664',
  },
  MT: {
    code: 'MLT',
    mask: ['####-####'],
    dialCode: '+356',
  },
  MU: {
    code: 'MUS',
    mask: ['###-####', '####-####'],
    dialCode: '+230',
  },
  MV: {
    code: 'MDV',
    mask: ['###-####'],
    dialCode: '+960',
  },
  MW: {
    code: 'MWI',
    mask: ['#-###-###', '####-####', '#-####-####'],
    dialCode: '+265',
  },
  MX: {
    code: 'MEX',
    mask: ['(###)###-####'],
    dialCode: '+52',
  },
  MY: {
    code: 'MYS',
    mask: ['0##-###-####', '0#-###-###'],
    dialCode: '+60',
  },
  MZ: {
    code: 'MOZ',
    mask: ['##-###-###', '###-###-###'],
    dialCode: '+258',
  },
  NA: {
    code: 'NAM',
    mask: ['0##-###-####'],
    dialCode: '+264',
  },
  NC: {
    code: 'NCL',
    mask: ['###-###'],
    dialCode: '+687',
  },
  NE: {
    code: 'NER',
    mask: ['##-##-####'],
    dialCode: '+227',
  },
  NF: {
    code: 'NFK',
    mask: ['03##-###', '35#-###', '32#-###'],
    dialCode: '+672',
  },
  NG: {
    code: 'NGA',
    mask: ['0(###)###-####'],
    dialCode: '+234',
  },
  NI: {
    code: 'NIC',
    mask: ['####-####'],
    dialCode: '+505',
  },
  NL: {
    code: 'NLD',
    mask: ['0##-###-####'],
    dialCode: '+31',
  },
  NO: {
    code: 'NOR',
    mask: ['###-###-####', '####-###-###'],
    dialCode: '+47',
  },
  NP: {
    code: 'NPL',
    mask: ['0##-###-###'],
    dialCode: '+977',
  },
  NR: {
    code: 'NRU',
    mask: ['###-####'],
    dialCode: '+674',
  },
  NU: {
    code: 'NIU',
    mask: ['####'],
    dialCode: '+683',
  },
  NZ: {
    code: 'NZL',
    mask: ['0(###)###-###', '0##-###-###', '0(###)###-####'],
    dialCode: '+64',
  },
  OM: {
    code: 'OMN',
    mask: ['##-###-###'],
    dialCode: '+968',
  },
  PA: {
    code: 'PAN',
    mask: ['###-####', '####-####'],
    dialCode: '+507',
  },
  PE: {
    code: 'PER',
    mask: ['0(###)###-###'],
    dialCode: '+51',
  },
  PF: {
    code: 'PYF',
    mask: ['##-##-##-##'],
    dialCode: '+689',
  },
  PG: {
    code: 'PNG',
    mask: ['(###)##-###', '###-####'],
    dialCode: '+675',
  },
  PH: {
    code: 'PHL',
    mask: ['0(###)###-####'],
    dialCode: '+63',
  },
  PK: {
    code: 'PAK',
    mask: ['0(###)###-####'],
    dialCode: '+92',
  },
  PL: {
    code: 'POL',
    mask: ['(###)###-###'],
    dialCode: '+48',
  },
  PM: {
    code: 'SPM',
    mask: ['###-###'],
    dialCode: '+508',
  },
  PN: {
    code: 'PCN',
    mask: null,
    dialCode: '+872',
  },
  PR: {
    code: 'PRI',
    mask: null,
    dialCode: '+1939',
  },
  PS: {
    code: 'PSE',
    mask: ['0##-###-####'],
    dialCode: '+970',
  },
  PT: {
    code: 'PRT',
    mask: ['##-###-####'],
    dialCode: '+351',
  },
  PW: {
    code: 'PLW',
    mask: ['###-####'],
    dialCode: '+680',
  },
  PY: {
    code: 'PRY',
    mask: ['0(###)###-###'],
    dialCode: '+595',
  },
  QA: {
    code: 'QAT',
    mask: ['####-####'],
    dialCode: '+974',
  },
  RE: {
    code: 'REU',
    mask: ['0#####-####'],
    dialCode: '+262',
  },
  RO: {
    code: 'ROU',
    mask: ['0##-###-####'],
    dialCode: '+40',
  },
  RS: {
    code: 'SRB',
    mask: ['0##-###-####'],
    dialCode: '+381',
  },
  RU: {
    code: 'RUS',
    mask: ['8(###)###-##-##'],
    dialCode: '+7',
  },
  RW: {
    code: 'RWA',
    mask: ['(###)###-###'],
    dialCode: '+250',
  },
  SA: {
    code: 'SAU',
    mask: ['05-####-####', '0#-###-####'],
    dialCode: '+966',
  },
  SB: {
    code: 'SLB',
    mask: ['###-####', '#####'],
    dialCode: '+677',
  },
  SC: {
    code: 'SYC',
    mask: ['#-###-###'],
    dialCode: '+248',
  },
  SD: {
    code: 'SDN',
    mask: ['0##-###-####'],
    dialCode: '+249',
  },
  SE: {
    code: 'SWE',
    mask: ['0##-###-####'],
    dialCode: '+46',
  },
  SG: {
    code: 'SGP',
    mask: ['####-####'],
    dialCode: '+65',
  },
  SH: {
    code: 'SHN',
    mask: ['#####'],
    dialCode: '+290',
  },
  SI: {
    code: 'SVN',
    mask: ['0##-###-###'],
    dialCode: '+386',
  },
  SJ: {
    code: 'SJM',
    mask: null,
    dialCode: '+47',
  },
  SK: {
    code: 'ARE',
    mask: ['0###-###-###'],
    dialCode: '+421',
  },
  SL: {
    code: 'SLE',
    mask: ['0##-######'],
    dialCode: '+232',
  },
  SM: {
    code: 'SMR',
    mask: ['####-######', '####-####'],
    dialCode: '+378',
  },
  SN: {
    code: 'SEN',
    mask: ['##-###-####'],
    dialCode: '+221',
  },
  SO: {
    code: 'SOM',
    mask: ['###-###-###', '##-###-###', '#-###-###', '###-###'],
    dialCode: '+252',
  },
  SR: {
    code: 'SUR',
    mask: ['0###-####', '0###-###'],
    dialCode: '+597',
  },
  SS: {
    code: 'SSD',
    mask: ['##-###-####'],
    dialCode: '+211',
  },
  ST: {
    code: 'STP',
    mask: ['##-#####'],
    dialCode: '+239',
  },
  SV: {
    code: 'SLV',
    mask: ['##-##-####'],
    dialCode: '+503',
  },
  SX: {
    code: 'SXM',
    mask: ['1###-####'],
    dialCode: '+721',
  },
  SY: {
    code: 'SYR',
    mask: ['0##-####-###'],
    dialCode: '+963',
  },
  SZ: {
    code: 'SWZ',
    mask: ['##-##-####'],
    dialCode: '+268',
  },
  TC: {
    code: 'TCA',
    mask: ['1###-####'],
    dialCode: '+1649',
  },
  TD: {
    code: 'TCD',
    mask: ['##-##-##-##'],
    dialCode: '+235',
  },
  TF: {
    code: 'ATF',
    mask: null,
    dialCode: '',
  },
  TG: {
    code: 'TGO',
    mask: ['##-###-###'],
    dialCode: '+228',
  },
  TH: {
    code: 'THA',
    mask: ['0##-###-####'],
    dialCode: '+66',
  },
  TJ: {
    code: 'TJK',
    mask: ['8##-###-####'],
    dialCode: '+992',
  },
  TK: {
    code: 'TKL',
    mask: ['####', '###-####'],
    dialCode: '+690',
  },
  TL: {
    code: 'TLS',
    mask: ['###-####', '###-#####'],
    dialCode: '+670',
  },
  TM: {
    code: 'TKM',
    mask: ['8#-###-####'],
    dialCode: '+993',
  },
  TN: {
    code: 'TUN',
    mask: ['##-###-###'],
    dialCode: '+216',
  },
  TO: {
    code: 'TON',
    mask: ['#####', '##-#####'],
    dialCode: '+676',
  },
  TR: {
    code: 'TUR',
    mask: ['0###-###-####'],
    dialCode: '+90',
  },
  TT: {
    code: 'TTO',
    mask: ['1###-####'],
    dialCode: '+1868',
  },
  TV: {
    code: 'TUV',
    mask: ['#####', '##-####', '###-####'],
    dialCode: '+688',
  },
  TW: {
    code: 'TWN',
    mask: ['0#-####-####', '0####-####'],
    dialCode: '+886',
  },
  TZ: {
    code: 'TZA',
    mask: ['0##-###-####'],
    dialCode: '+255',
  },
  UA: {
    code: 'UKR',
    mask: ['0##-###-##-##'],
    dialCode: '+380',
  },
  UG: {
    code: 'UGA',
    mask: ['0###-###-###'],
    dialCode: '+256',
  },
  UK: {
    code: 'GBR',
    mask: ['0##-####-####'],
    dialCode: '+44',
  },
  UY: {
    code: 'URY',
    mask: ['0#-###-##-##'],
    dialCode: '+598',
  },
  UZ: {
    code: 'UZB',
    mask: ['0##-###-####'],
    dialCode: '+998',
  },
  VA: {
    code: 'VAT',
    mask: ['06-698-#####'],
    dialCode: '+379',
  },
  VC: {
    code: 'VCT',
    mask: ['1###-####'],
    dialCode: '+1784',
  },
  VE: {
    code: 'VEN',
    mask: ['0###-###-####'],
    dialCode: '+58',
  },
  VG: {
    code: 'VGB',
    mask: ['1###-####'],
    dialCode: '+1284',
  },
  VI: {
    code: 'VIR',
    mask: ['1###-####'],
    dialCode: '+1340',
  },
  VN: {
    code: 'VNM',
    mask: ['0##-####-###'],
    dialCode: '+84',
  },
  VU: {
    code: 'VUT',
    mask: ['##-#####', '#####'],
    dialCode: '+678',
  },
  WF: {
    code: 'WLF',
    mask: ['##-####'],
    dialCode: '+681',
  },
  WS: {
    code: 'WSM',
    mask: ['#-####', '###-####'],
    dialCode: '+685',
  },
  YE: {
    code: 'YEM',
    mask: ['0###-###-###', '0#-###-###', '0##-###-###'],
    dialCode: '+967',
  },
  YT: {
    code: 'MYT',
    mask: ['0-##-##-##'],
    dialCode: '+262',
  },
  ZA: {
    code: 'ZAF',
    mask: ['0##-###-####'],
    dialCode: '+27',
  },
  ZM: {
    code: 'ZMB',
    mask: ['0##-###-####'],
    dialCode: '+260',
  },
  ZW: {
    code: 'ZWE',
    mask: ['0#-######'],
    dialCode: '+263',
  },
} as unknown) as Record<string, ICountryPhoneInfo>)

export const ZIPCODE_MASK: Record<string, string> = Object.freeze({
  JPN: '###-####',
  USA: '#####-####',
  CHN: '######',
})

export const PHONE_MASK: Record<string, string> = Object.freeze({
  JPN: '###-####-####',
  USA: '###-###-####',
  CHN: '###########',
  DEFAULT: '###############',
})

export const FIELD_TYPE: Record<string, string> = Object.freeze({
  TEXT: 'text',
  NUMBER: 'number',
  ADJUSTMENT: 'adjustment',
  SINGLE_SELECT: 'singleSelect',
  MULTI_SELECT: 'multiSelect',
  DATE: 'date',
  DATE_TIME: 'dateTimeData',
  ESIGN: 'eSign',
  FILES: 'files',
  LOCATION: 'location',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
  REFERENCE: 'reference',
  GHG_EMISSION: 'ghgEmission',
  CALCULATION: 'calculation',
  WEIGHT_MEASUREMENT: 'weightMeasurement',
  LIST_STRING: 'listString',
})

export const BARCODE_ICONS: Record<string, string> = Object.freeze({
  ORPHAN: 'orphan',
  NODE: 'node',
  LEAF: 'leaf',
  VACCINE: 'vaccine',
  TRUCK: 'truck',
  CONTAINER: 'container',
  TIMETABLE: 'timetable',
  INVENTORY: 'inventory',
  WAREHOUSE: 'warehouse',
  RACK: 'rack',
  FORKLIFT: 'forklift',
  PACKAGES: 'packages',
  PACKAGE: 'package',
  PAPER: 'paper',
  PERSON: 'person',
  TRAIN: 'train',
  SHIP: 'ship',
  AIRPLANE: 'airplane',
})

export const DATE_TIME: Record<string, string> = Object.freeze({
  PARAM_FORMAT: 'YYYYMMDD',
  DISPLAY_FORMAT: 'yyyy/MM/dd',
  RESPONSE_FORMAT: 'YYYY-MM-DD',
  FORMAT: 'YYYY/MM/DD h:mm a',
  MONTH_DAY: 'MM/dd',
  WITH_SECOND: 'yyyy-MM-dd kk:mm:ss',
  WITHOUT_SECOND: 'yyyy-MM-dd',
  TIME_WITHOUT_SECOND_FORMAT: 'HH:mm',
  WITHOUT_SECOND_FORMAT: 'YYYY/MM/DD HH:mm',
  TIME_WITH_SECOND_FORMAT: 'HH:mm:ss',
  LL_DATE_DISPLAY_FORMAT: 'LL',
})

export const ALLOWED_SERIAL_PREFIX: Record<string, string> = Object.freeze({
  TP: 'TP',
  BT: 'BT',
})

export const LEFT_AMOUNT_START_TROLLEY_INDEX = 9001
export const SCANNED_DEVICE_KEY = 'machine'

export const PROJECT_CODE = 'tracetest'

export const TABLET_WIDTH = '(min-width: 768px)'

export const PROJECT_VERSION = '2'

export const PROJECT_PATH = `${PROJECT_CODE}@${PROJECT_VERSION}`

export const LINKED_BARCODE_HREF_TYPE = Object.freeze({
  snapshot: 'snapshot',
  latest: 'latest',
})

export const LINKED_BARCODE_PATH_KEY = Object.freeze({
  activationData: 'activationData',
  trackingData: 'trackingData',
  linkedBarcodes: 'linkedBarcodes',
})

export const BARCODE_ACTIVATION_DATA_KEYS: Record<string, string> = Object.freeze({
  customTextBoxes: 'text',
  customTextAreas: 'textarea',
  customNumberInputs: 'number',
  customRadioButtons: 'radio',
  customCheckBoxes: 'check',
  customDateInputs: 'date',
})

export const MASKED_STR = '***'

export const UNIT_OPTIONS = Object.freeze(['PCS', 'KG', 'BTL', 'C/S', 'L', 'M', 'KAN', 'SET', 'CAN', 'HON'])

export const DEFAULT_MAX_RETRIES = 4
export const DEFAULT_DELAY_MS = 200

export const DEFAULT_DEBOUNCE_TIME = 400
export const POSITIVE_DECIMAL_REGEX = /^\d*\.?\d+$/
